import { createContext } from 'react'

/** @type {import('react').Context<null | {
 *   isOpen: boolean,
 *   openThreadDocuments: () => void,
 *   closeThreadDocuments: () => void,
 *   toggleThreadDocuments: () => void,
 * }>} */
export const ThreadDocumentsContext = createContext(null)
